import {
  createHashRouter,
  RouterProvider
} from "react-router-dom";
import Container from '@mui/material/Container';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import { Summary } from './components/Summary';
import { Charity } from './components/Charity';
import {AccountButton} from './components/AccountButton'
import { useEthers} from '@usedapp/core';

interface AppProps {
  supportedChainId: number;
} 

export const App = ({supportedChainId} : AppProps) => {

  const customTheme = createTheme({
    palette: {
      primary: purple
    }
  });

  const { account, chainId, switchNetwork } = useEthers();

  const router = createHashRouter([
    
    {
      path: "/",
      element: <Summary/>,
    },
    {
      path: "/readonly/:readOnlyAccount",
      element: <Summary/>,
    },
    {
      path: "/charity",
      element: <Charity account={account} chainId={chainId}/>,
    }
  ]);


  if(chainId !== supportedChainId){
    try{
      switchNetwork(supportedChainId);
    } catch(e){
      console.error(e);
    }
  }

  return (
      <ThemeProvider theme={customTheme}>
        <AccountButton account={account}/>
        <Container maxWidth={false} style={{padding: 0}}>
          <RouterProvider router={router} />
        </Container>
      </ThemeProvider>
  );
}

export default App;
